import { Dispatch, SetStateAction, useCallback } from 'react'
import { FirebaseDocRefType } from 'firebase/index'
import { StockUnionType } from 'types/stock'
import { getInitialScheduleValue } from 'reducks/schedule/selectors'
import { ScheduleType } from 'types/schedule'
import { getUpdateSchedulesFunction } from 'components/Templates/product/ProductEditTemplate'

const useAddSchedule = (
  breadRef: FirebaseDocRefType,
  setDailySchedules: Dispatch<SetStateAction<ScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<ScheduleType[]>>
): ((scheduleRef: FirebaseDocRefType, type: StockUnionType) => void) => {
  return useCallback(
    (scheduleRef: FirebaseDocRefType, type: StockUnionType) => {
      const update = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!update) return
      update((prevState) => {
        const defaultSchedule = prevState[0] ?? undefined
        return [...prevState, getInitialScheduleValue(breadRef, scheduleRef, type, defaultSchedule)]
      })
    },
    [breadRef, setDailySchedules, setPreorderSchedules]
  )
}

export default useAddSchedule
